// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/legacy_portal_service.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest, LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse, LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest, LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse, LegacyPortalDashboardServiceGetEventRolesRequest, LegacyPortalDashboardServiceGetEventRolesResponse, LegacyPortalDashboardServiceGetEventSalesDetailsRequest, LegacyPortalDashboardServiceGetEventSalesDetailsResponse, LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest, LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse, LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest, LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse, LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest, LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse, LegacyPortalDashboardServiceGetUserAttributeCountsRequest, LegacyPortalDashboardServiceGetUserAttributeCountsResponse } from "./legacy_portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.dashboard.v1.LegacyPortalDashboardService
 */
export const LegacyPortalDashboardService = {
    typeName: "spwn.dashboard.v1.LegacyPortalDashboardService",
    methods: {
        /**
         * ダッシュボード一覧画面用の権限のあるイベント一覧を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetEventRoles
         */
        getEventRoles: {
            name: "GetEventRoles",
            I: LegacyPortalDashboardServiceGetEventRolesRequest,
            O: LegacyPortalDashboardServiceGetEventRolesResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * チケットもぎりダッシュボード画面から呼び出されるAPI
         * チケットidを元にチケットの詳細情報を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetAllIssuedTicketSummary
         */
        getAllIssuedTicketSummary: {
            name: "GetAllIssuedTicketSummary",
            I: LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest,
            O: LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * 購入情報確認ダッシュボード画面から呼び出されるAPI
         * イベントの販売詳細情報を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetEventSalesDetails
         */
        getEventSalesDetails: {
            name: "GetEventSalesDetails",
            I: LegacyPortalDashboardServiceGetEventSalesDetailsRequest,
            O: LegacyPortalDashboardServiceGetEventSalesDetailsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * 注文日別のチケット販売枚数を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetTicketSalesByOrderDate
         */
        getTicketSalesByOrderDate: {
            name: "GetTicketSalesByOrderDate",
            I: LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest,
            O: LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * ユーザー属性別のチケット販売数を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetUserAttributeCounts
         */
        getUserAttributeCounts: {
            name: "GetUserAttributeCounts",
            I: LegacyPortalDashboardServiceGetUserAttributeCountsRequest,
            O: LegacyPortalDashboardServiceGetUserAttributeCountsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * チケット購入者の質問結果を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetTicketQuestionnaireResults
         */
        getTicketQuestionnaireResults: {
            name: "GetTicketQuestionnaireResults",
            I: LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest,
            O: LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * 自由記述の設問回答をページネーションで追加取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetTicketQuestionnaireTextAnswers
         */
        getTicketQuestionnaireTextAnswers: {
            name: "GetTicketQuestionnaireTextAnswers",
            I: LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest,
            O: LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * 購入情報確認ダッシュボードのrowデータファイルを取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.ExportPurchaseDashboardRowsFile
         */
        exportPurchaseDashboardRowsFile: {
            name: "ExportPurchaseDashboardRowsFile",
            I: LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest,
            O: LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map